/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';

import FormField from '../helpers/FormField';
import { Checkbox, CheckboxList, RadioGroup, RadioItem } from '../../../uiold';
import Dropdown from '../../../uiold/Dropdown';

import toStringArray from '../../../../support/shared/toStringArray';
import { ensureDefaultSelected, getType } from '../helpers/MultichoiceHelpers';
import { FormContext } from '../../../Embed/FormEmbed';
import {
  formatChoiceWithCharge,
  parseChargeFromValue,
} from '../../../../support/shared/calculatePrice';

import { FormFieldDefinition } from '../../../../types/shared/FormFieldDefinition';

type Props = {
  definition: FormFieldDefinition;
  readOnly?: boolean;
  onChange?: (id: string, value: Array<string>) => void;
};

type State = {
  selected: Array<string>;
};

class MultichoiceElementFormView extends PureComponent<Props, State> {
  state: State = {
    selected: ensureDefaultSelected(this.props.definition, []),
  };

  componentDidUpdate(prevProps: Props) {
    if (getType(this.props.definition) !== getType(prevProps.definition)) {
      this.setState({
        selected: ensureDefaultSelected(this.props.definition, []),
      });
    }
  }

  render() {
    let { props } = this;
    return (
      <FormContext.Consumer>
        {(data) => (
          <FormField {...props}>
            <View style={styles.fieldDiv}>
              {this._renderField(data ? data.accountCurrency : 'USD')}
            </View>
          </FormField>
        )}
      </FormContext.Consumer>
    );
  }

  _renderField = (accountCurrency: string): any => {
    let { definition, readOnly } = this.props;

    // TODO: Better solution here.
    if (definition.type !== 'MultichoiceElement') {
      return null;
    }
    let tabIndex = readOnly ? -1 : undefined;
    let { options } = definition;

    if (!Array.isArray(options)) {
      return null;
    }
    let selectedSet = new Set(this.state.selected);
    let optionsWithCharge = parseChargeFromValue(options);

    if (definition.condensed) {
      let selectedChoice;
      let choices = [];
      for (let option of optionsWithCharge) {
        let { name, charge, operator } = option;
        let choice = {
          id: option.id,
          name: formatChoiceWithCharge(name, charge, accountCurrency, operator),
        };
        choices.push(choice);
        if (option.id === this.state.selected[0]) {
          selectedChoice = choice;
        }
      }

      return (
        <Dropdown
          options={choices}
          value={selectedChoice}
          tabIndex={tabIndex}
          onChange={(selectedOption) => {
            this._onChange(selectedOption.id);
          }}
        />
      );
    }

    if (definition.allow_multi) {
      return (
        <CheckboxList
          showSelectAll={options.length >= 4 && !definition.disable_select_all}
          alignHorizontal
          onSelectionChange={this._onSelectionChange}
        >
          {optionsWithCharge.map((option) => {
            let { name, value, charge, operator } = option;
            let formattedOption = formatChoiceWithCharge(
              name,
              charge,
              accountCurrency,
              operator,
            );
            let isChecked = selectedSet.has(option.id);
            return (
              <Checkbox
                key={option.id}
                tabIndex={tabIndex}
                isChecked={isChecked}
                text={charge ? formattedOption : value}
              />
            );
          })}
        </CheckboxList>
      );
    } else {
      return (
        <RadioGroup
          selectedValue={this.state.selected[0]}
          alignHorizontal
          onChange={this._onChange}
        >
          {optionsWithCharge.map((option, i) => {
            let { name, charge, operator } = option;
            let formattedOption = formatChoiceWithCharge(
              name,
              charge,
              accountCurrency,
              operator,
            );
            return (
              <RadioItem
                key={i}
                tabIndex={tabIndex}
                value={option.id}
                title={charge ? formattedOption : name}
              />
            );
          })}
        </RadioGroup>
      );
    }
  };

  _onChange = (value: unknown) => {
    let { onChange, definition } = this.props;
    // TODO: Better solution here.
    if (definition.type !== 'MultichoiceElement') {
      return;
    }
    let selected = [String(value)];

    this.setState({ selected });
    if (onChange != null) {
      onChange(definition.id, selected);
    }
  };

  _onSelectionChange = (selectedKey: Set<string>) => {
    let { onChange, definition } = this.props;
    // TODO: Better solution here.
    if (definition.type !== 'MultichoiceElement') {
      return;
    }

    if (definition.allow_multi) {
      let { options } = definition;
      if (!Array.isArray(options)) {
        options = [];
      }
      let selected = options
        .filter((option) => selectedKey.has(option.id))
        .map((option) => option.id);

      this.setState({
        selected: ensureDefaultSelected(definition, selected),
      });
      if (onChange != null) {
        onChange(definition.id, selected);
      }
    }
  };

  setValue = (input: unknown) => {
    let items = toStringArray(input);
    let { definition } = this.props;
    let options = toStringArray(
      (definition as {
        [key: string]: any;
      }).options,
    );
    let availableValues = new Set(options);
    let selected = items.filter((item: string) => availableValues.has(item));
    this.setState({
      selected: ensureDefaultSelected(definition, selected),
    });
  };

  getValue = () => {
    return this.state.selected;
  };
}

let styles = StyleSheet.create({
  fieldDiv: {
    flexDirection: 'column',
  },
});

export default MultichoiceElementFormView;
